import cx from "classnames";
import { type ReactElement, ReactNode, HTMLProps } from "react";
import * as s from "./styles";

interface Props extends HTMLProps<HTMLDivElement> {
  children?: ReactNode;
  dataTestId?: string;
  className?: string;
}

export default function GlassCard({
  children,
  dataTestId,
  className,
  ...rest
}: Props): ReactElement {
  return (
    <div
      className={cx(s.glassCard, className)}
      data-testid={dataTestId}
      {...rest}
    >
      {children}
    </div>
  );
}
